import styled from 'styled-components';

const Wrapper = styled.div<{ $thinRow?: boolean; }>`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.colors.surface_muted};
  border-radius: 12px;
  margin-bottom: 10px;
  height: ${(props) => `${props.$thinRow ? 72 : 100}px`};

  .dot {
    height: 10px;
    width: 10px;
    background-color: #bbb;
    border-radius: 50%;
    margin: 0 16px;

    &.red {
      background-color: ${(props) => props.theme.colors.red};
    }

    &.yellow {
      background-color: ${(props) => props.theme.colors.main_cta};
    }

    &.green {
      background-color: ${(props) => props.theme.colors.green};
    }

    &.orange {
      background-color: ${(props) => props.theme.colors.orange};
    }

    &.salmon {
      background-color: ${(props) => props.theme.colors.salmon};
    }

    &.light-yellow {
      background-color: ${(props) => props.theme.colors.light_yellow};
    }
  }

  .count {
    padding: 4px 0;
    font-family: 'ManropeExtraBold';
    font-size: 35px;
    color: ${(props) => props.theme.colors.text};
  }

  .label {
    margin-left: 10px;
    font-size: 14px;
    color: ${(props) => props.theme.colors.text};
  }
`;

export default { Wrapper };
